import { ChangeEvent } from "react";
import { Modal } from '@employ-engage/common-components';

export interface UpdateAvatarModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onUpload: (e: ChangeEvent) => void;
}

export function UpdateAvatarModal({
  open,
  setOpen,
  onUpload,
}: UpdateAvatarModalProps) {
  return (
    <Modal open={open} setOpen={setOpen} panelClassName="w-full max-w-[400px]">
      <input type="file" id="thumbnailUpload" name="thumbnailUpload" accept=".img,.jpg,.png" onChange={onUpload}/>
    </Modal>
  );
}

export default UpdateAvatarModal;
